import { Component, OnDestroy, OnInit } from '@angular/core';
import { FarmoutConfigurationService } from '../services/farmout-configuration.service';
import { ActivatedRoute, Router } from '@angular/router';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-farmout-configurations',
  templateUrl: './add-farmout-configurations.component.html',
  styleUrls: ['./add-farmout-configurations.component.css']
})
export class AddFarmoutConfigurationsComponent implements OnInit, OnDestroy {
  configurationForm: FormGroup;
  configurationId;
  submitted = false;
  timeZone = 'America/Los_Angeles';
  platforms: string[] = ['v1', 'v2', 'v3', 'v4', 'v5', 'v6', 'v7', 'v8', 'v9'];
  constructor(
    private fb: FormBuilder,
    private farmoutConfigurationService: FarmoutConfigurationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.activatedRoute.params
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((params) => {
        this.configurationId = params["id"];

      });

    this.configurationForm = this.fb.group({
      name: ['', Validators.required],
      companyId: ['', Validators.required],
      status: ['active'],
      timeZone: ['', Validators.required],
      platform: ['', Validators.required]
    });

    this.getDetails();

  }

  getDetails() {
    if (this.configurationId) {
      this.farmoutConfigurationService
        .getFarmoutConfigurationById(this.configurationId)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            this.configurationForm.patchValue(data);
            this.timeZone = data.timeZone;
          }
        });
    }
  }

  addFarmoutConfiguration() {
    this.submitted = true;
    if (this.configurationForm.invalid) {
      return
    }

    let payload = this.configurationForm.value;

    if (this.configurationId) {
      this.farmoutConfigurationService.updateFarmoutConfiguration(this.configurationId, payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            this.router.navigateByUrl('/operations/farmout-configuration');
          }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
    } else {
      this.farmoutConfigurationService.addFarmoutConfiguration(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            this.router.navigateByUrl('/operations/farmout-configuration');
          }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
    }
    this.submitted = false;

  }

  get form() {
    return this.configurationForm.controls;
  }

  changeTimezone() {
     this.configurationForm.patchValue({ timeZone: this.timeZone });
  }

  ngOnDestroy(): void {
  }
}
